import {Directive, ElementRef, Input, OnInit, Renderer} from '@angular/core';

@Directive({
  selector: '[dynamic-col]',
})

export class DynamicColDirective implements OnInit {
  @Input('dynamic-col') value: string;

  constructor(private el: ElementRef, private _renderer: Renderer) {}

  ngOnInit() {

    let widths : string[] = this.value.split(";");

    widths.forEach(w => {
      let widthItem : string[] = w.split("=");
      let widthType : string = widthItem[0];
      let widthTypeValue : string = widthItem[1];

      this._renderer.setElementAttribute(this.el.nativeElement, 'col-'+widthType+'-'+widthTypeValue, '');
    });

  }
}



// WEBPACK FOOTER //
// ./src/directive/DynamicColDirective.ts